var _defs, _g, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logosandtypes_com",
    "data-name": "logosandtypes com",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ff5200;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer_3",
    "data-name": "Layer 3",
    className: "cls-1",
    d: "M0,.2H150v150H0Z",
    transform: "translate(0 -0.2)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.41,18.57H38c-13.83,0-23.33,9.51-23.33,23.33v67.4c0,13.82,9.5,23.33,23.33,23.33h73.44c13.82,0,23.33-9.51,23.33-23.33v-19H107.09L95,111H53.52L32.78,75.6,53.52,40.17H95l12.1,20.74h27.65v-19C134.74,28.08,125.23,18.57,111.41,18.57Z",
    transform: "translate(0 -0.2)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "63.89 55.53 52.66 75.4 63.89 94.41 86.35 94.41 97.58 75.4 86.35 55.53 63.89 55.53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcore);
export default __webpack_public_path__ + "static/media/procore.76ed451256ef5e44a6b6acdc13266a02.svg";
export { ForwardRef as ReactComponent };